/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KevFindingDto
 */
export interface KevFindingDto {
    /**
     * 
     * @type {string}
     * @memberof KevFindingDto
     */
    instanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof KevFindingDto
     */
    cveId?: string;
    /**
     * 
     * @type {string}
     * @memberof KevFindingDto
     */
    severity?: string;
    /**
     * 
     * @type {Date}
     * @memberof KevFindingDto
     */
    kevDueDate?: Date;
}

/**
 * Check if a given object implements the KevFindingDto interface.
 */
export function instanceOfKevFindingDto(value: object): value is KevFindingDto {
    return true;
}

export function KevFindingDtoFromJSON(json: any): KevFindingDto {
    return KevFindingDtoFromJSONTyped(json, false);
}

export function KevFindingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KevFindingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
        'cveId': json['cveId'] == null ? undefined : json['cveId'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'kevDueDate': json['kevDueDate'] == null ? undefined : (new Date(json['kevDueDate'])),
    };
}

export function KevFindingDtoToJSON(json: any): KevFindingDto {
    return KevFindingDtoToJSONTyped(json, false);
}

export function KevFindingDtoToJSONTyped(value?: KevFindingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instanceId': value['instanceId'],
        'cveId': value['cveId'],
        'severity': value['severity'],
        'kevDueDate': value['kevDueDate'] == null ? undefined : ((value['kevDueDate']).toISOString().substring(0,10)),
    };
}

